// ABOUTME: Hook for managing a player's identity within a specific game.
// ABOUTME: Persists the GamePlayer ID in localStorage, keyed by gameId.
import { useState } from 'react';

const storageKey = (gameId: string) => `gamePlayer_${gameId}`;

export function useGamePlayer(gameId: string) {
  const [gamePlayerId, setGamePlayerIdState] = useState<string | null>(
    () => localStorage.getItem(storageKey(gameId)),
  );

  const setGamePlayerId = (id: string) => {
    localStorage.setItem(storageKey(gameId), id);
    setGamePlayerIdState(id);
  };

  return { gamePlayerId, setGamePlayerId };
}
